export const Urls = {
  GetYearOnYearInitData: "MepYearOverYear/GetYearOnYearInitData",
  GetYearOverYearEmissions: "MepYearOverYear/GetYearOverYearEmissions",
  GetYearOverYearEmissionStatistics: "MepYearOverYear/GetYearOverYearEmissionStatistics",
}

export const MepYoYChartColors: string[] = ["#1A8574",
"#003745",
"#EAA80D",
"#007991"]